// Tenant credentials from the login response (LoginPage.js), read fresh on
// every request so a login/logout in one tab is picked up immediately.
export const applyTenantHeaders = (config) => {
  const tenantId = localStorage.getItem('crm_tenant_id');
  const tenantToken = localStorage.getItem('crm_tenant_token');
  if (tenantId) config.headers['X-Tenant-ID'] = tenantId;
  if (tenantToken) config.headers['X-Tenant-Token'] = tenantToken;
  return config;
};

// `api.js`'s axios.create() instance only covers call sites that import it.
// Most of the app does `import axios from 'axios'` directly, and every such
// import shares this same singleton — so installing here once, at boot,
// covers those raw axios.get/post/... calls too (same pattern as
// installTimeoutInterceptor in timeoutInterceptor.js).
export const installTenantHeaderInterceptor = (instance) => {
  instance.interceptors.request.use(applyTenantHeaders);
};
